import { render, staticRenderFns } from "./TianjiaHuowuTwo.vue?vue&type=template&id=7600c91b&"
import script from "./TianjiaHuowuTwo.vue?vue&type=script&lang=js&"
export * from "./TianjiaHuowuTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports